import { Switch as AntSwitch, SwitchProps } from 'antd';

export const Switch = ({ className, onChange, ...props }: SwitchProps) => {
  return <AntSwitch className={className} onChange={onChange} {...props} />;
};
